export const SET_QUIZ_RESULTS = 'viewer/quiz_results/SET_QUIZ_RESULTS';
export const SET_QUIZ_RESULT = 'viewer/quiz_results/SET_QUIZ_RESULT';
